import permissionsData from 'common/data/permissions.json';

export class Permission {
	static permissions = permissionsData;
}

export const PERMISSIONS = {};

permissionsData.forEach((section) => {
	PERMISSIONS[section.section] = {};
	section.permissions.forEach((permission) => {
		PERMISSIONS[section.section][permission.code] = permission;
	});
});	


